import { useEffect, useReducer } from 'react';

import {
  ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES,
  ADJUSTS_CREDITS_DEMAND_FRAME_MS,
  ADJUSTS_CREDITS_DEMAND_REDUCED_MOTION_FRAME,
} from './AdjustsCreditsPanel.constants';

const frameToState = frame => ({
  frameIndex: frame.frameIndex,
  figmaVariant: frame.figmaVariant,
  demandHeight: frame.demandHeight,
  creditHeight: frame.creditHeight,
  demandActive: Boolean(frame.demandActive),
  creditActive: Boolean(frame.creditActive),
});

const initialAnimatedState = frameToState({
  ...ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES[0],
  frameIndex: 0,
});

const actionTypes = {
  APPLY_FRAME: 'APPLY_FRAME',
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.APPLY_FRAME:
      return { ...state, ...action.frameState };
    default:
      return state;
  }
};

export const useAdjustsCreditsDemandAnimation = ({ prefersReducedMotion = false } = {}) => {
  const [state, dispatch] = useReducer(
    reducer,
    prefersReducedMotion ? frameToState(ADJUSTS_CREDITS_DEMAND_REDUCED_MOTION_FRAME) : initialAnimatedState
  );

  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }

    let frameIndex = 0;
    let timeoutId = null;
    let cancelled = false;

    const scheduleNextFrame = () => {
      const frame = ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES[frameIndex];

      timeoutId = setTimeout(() => {
        if (cancelled) {
          return;
        }

        frameIndex = (frameIndex + 1) % ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES.length;
        const nextFrame = ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES[frameIndex];

        dispatch({
          type: actionTypes.APPLY_FRAME,
          frameState: frameToState({ ...nextFrame, frameIndex }),
        });

        scheduleNextFrame();
      }, frame.holdMs ?? ADJUSTS_CREDITS_DEMAND_FRAME_MS);
    };

    scheduleNextFrame();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [prefersReducedMotion]);

  return state;
};
